﻿'use strict';

angular.module('ntmApp')
  .directive('truncatedItemTooltip', function () {
      return {
          restrict: 'E',
          templateUrl: 'ng1/src/directives/templates/truncatedItemTooltip.html',
          scope: {
              itemToTruncate: '=',
              itemsContainerShouldIgnore: '='
          },
          link: function ($scope, element) {

              $scope.isTruncated = function () {
                  var $parent = $(element).parent();

                  var containerWidth = $parent.width();
                  var otherInnerElementsSummaryWidth = 0;

                  $($parent[0].children).each(function (index) {
                      var child = $($parent[0].children[index]);

                      if (!(child.is('truncated-item-tooltip'))) {

                          if ($scope.itemsContainerShouldIgnore) {
                              if (((_us.intersection(child[0].classList, $scope.itemsContainerShouldIgnore)).length <= 0)) {
                                  otherInnerElementsSummaryWidth += child.innerWidth();
                              }
                          }
                          else
                          {
                              otherInnerElementsSummaryWidth += child.innerWidth();
                          }
                      }
                  });

                  if ((containerWidth - otherInnerElementsSummaryWidth) < $(element).innerWidth()) {
                      return true;
                  }
                  else {
                      return false;
                  }
              };
          }
      };
  });